import React from "react";

interface TextFieldProps {
	label: React.ReactNode;
	value: string;
	onChange: (value: string) => void;
	type?: string;
	placeholder?: string;
	errors?: string[];
	tabIndex?: number;
	headerRight?: React.ReactNode;
}

export const TextField: React.FC<TextFieldProps> = (props) => {
	return (
		<label className={"mb-4"}>
			<div className={"text-xs text-slate-300 my-1 flex justify-between"}>
				<div>{props.label}</div>
				{props.headerRight}
			</div>
			<input
				type={props.type ?? "text"}
				placeholder={props.placeholder ?? (typeof props.label === "string" ? props.label : "")}
				value={props.value}
				tabIndex={props.tabIndex}
				onChange={(e) => props.onChange(e.currentTarget.value)}
				className={"rounded border border-slate-600 bg-slate-200 p-1 text-slate-800 w-full"}
			/>
			{props.errors?.map((e) => (
				<div className={"text-red-400 text-xs"} key={e}>
					{e}
				</div>
			))}
		</label>
	);
};
